import React, {useState} from 'react';
import {View, Text, StyleSheet} from 'react-native';
import TitleBlock from '../../components/TitleBlock';
import Themes from '../../themes';
import FormCSTM from '../../form/FormCSTM';

const SimuCSTM = ({navigation}) => {
  const [CSTS_Precompter, setCSTS_Precompter] = useState(0);
  const [CSTS_Total, setCSTS_Total] = useState(0);
  const [revenuTotal, setRevenuTotal] = useState(0);
  const [restant, setRestant] = useState(0);

  const form = (
    <View style={[styles.scene]}>
      <FormCSTM
        setCSTS_Precompter={setCSTS_Precompter}
        setCSTS_Total={setCSTS_Total}
        setRevenuTotal={setRevenuTotal}
        setRestant={setRestant}
      />
    </View>
  );

  const results = (
    <View style={[styles.scene]}>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT TOTAL DES REVENUS PERCUS</Text>
        <Text style={[styles.result]}>{revenuTotal}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT TOTAL DE LA CST DUE</Text>
        <Text style={[styles.result]}>{CSTS_Total}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT DE LA CST-S PRÉCOMPTÉE</Text>
        <Text style={[styles.result]}>{CSTS_Precompter}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT TOTAL DE LA CST-M DUE</Text>
        <Text style={[styles.result]}>{restant}</Text>
      </View>
    </View>
  );

  return (
    <>
      <TitleBlock
        bgColor={Themes.colors.blue}
        textColor="white"
        image={require('../../assets/home-icon-pig.png')}>
        Contribution de solidarité territoriale sur les revenus multiples
      </TitleBlock>
      {form}
      {results}
    </>
  );
};

const styles = StyleSheet.create({
  scene: {
    flex: 1,
    padding: 20,
  },
  resultItem: {
    flexDirection: 'row',
    paddingVertical: 3,
    borderBottomWidth: 3,
    borderBottomColor: Themes.colors.lightBlue,
    borderStyle: 'dashed',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    flex: 1,
    flexGrow: 2,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
  },
  result: {
    flex: 1,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
    textAlign: 'right',
  },
});

export default SimuCSTM;
